<div class="container">
  <div id="center">
    <div class="center">
        <img class="center" src="assets/images/images.png"/>
        <h2>Ever wondered if you could<br />
          Look up and search up users/Repos<br />
       on Github?<br />
       Worry no more because Github search will help us look
       <hr/>
       Get ready to search below!</h2>    
      </div>
  </div>
   </div>
<div class="jumbotron text-center">  
  <div class="container-fluid">
    <div>
        <input type="text"  [(ngModel)]="username" id="mySearch" placeholder="Search.." title="Type in a category"><button (click)="search()" class="btn btn-primary">Search</button>
      </div><br>
    <div class="row">
      <div  class="col-sm-6" >
        <img width="200" alt="portfolio_view"src={{github?.avatar_url}} alt="">
      </div>
      <div class="well">
      <div  *ngIf ="github" class="col-sm-6" id="identity">
        <h5 class="hello">Login:{{github?.login}}</h5>
        <h5 class="hello">Name:{{ github?.name}}</h5>
        <h5 class="hello">Bio:{{github?. bio}}</h5>
        <h5 class="hello">Location:{{ github?.location}}</h5>
        <h5 class="hello">Created:{{ github?.created_at|date}}</h5>
        <a href="{{github.html_url}}" target="_blank"><button class="list-group-item list-group-item-action active">View them in profile</button></a>
      </div>
    </div>
   </div>      
  </div>
  </div>